<template>
    <div class="literature-database-wrapper">
        <div class="literature-database-overview-wrapper">
            <RowsExplain :title="$t('page.status.Overview')"/>
            <div class="literature-database-overview-list">
                <div class="literature-database-overview-item" v-for="(item,index ) in overList" :key="index">
                    <div class="literature-database-overview-item-count">{{ item.count }}</div>
                    <div class="literature-database-overview-item-name">{{ item.name }}</div>
                </div>
            </div>
        </div>
        <div class="literature-database-publication-list-wrapper">
            <RowsExplain :title="publicationListTitle"/>
            <div class="literature-database-publication-list-desc">{{ $t('page.status["tip"]') }}</div>
            <table class="literature-database-table">
                <thead>
                <tr>
                    <th v-for="(item,index) in columnList" :key="index">{{item.title}}
                    </th>
                </tr>
                </thead>
                <tbody v-for="(item, index) in data.currentPubList" :key="index">
                <tr :class="{'row--stripe':index%2===1}">
                    <td>{{formatName(item.name)}}</td>
                    <td>{{formatCount(item.count)}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import RowsExplain from '../../../components/rows-explain/RowsExplain';

import formatNumber from '../../../../../utils/formatNumber';
import { get } from 'lodash';

/**
 * 文献期刊数据库
 */
export default {
    name: 'LiteratureDatabase',
    components: {
        RowsExplain,
    },
    props: {
        data: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {
            publicationListTitle: this.$t('page.status["Publication List"]'),
            columnList: [
                { field: 'name', title: this.$t('page.status["Publication List"]'), },
                { field: 'count', title: this.$t('page.status["Amount"]'), }
            ]
        };
    },
    methods: {
        formatName(cellValue) {
            return cellValue === '-' ? this.$t('page.status["e-prints"]') : cellValue;
        },
        formatCount(cellValue) {
            return formatNumber(cellValue);
        }
    },
    computed: {
        overList() {
            return [
                { name: this.$t('page.status["Amount"]'), count: formatNumber(get(this.data, 'overview.total', 0)) },
                {
                    name: this.$t('page.status["Abstract"]'),
                    count: formatNumber(get(this.data, 'overview.abstractCount', 0))
                },
                { name: this.$t('page.status["Pdf"]'), count: formatNumber(get(this.data, 'overview.pdfCount', 0)) },
            ];
        }
    }
};
</script>

<style lang="scss">
.literature-database-wrapper {
    background: $bg-white;
    width: 1280px;
    margin: 0 auto;
    padding: 0 36px 36px;
    box-sizing: border-box;

    .literature-database-overview-wrapper {
        background: $bg-white;
        padding-bottom: 16px;
        position: sticky;
        top: 106px;
        z-index: 20;

        .literature-database-overview-list {
            display: flex;

            .literature-database-overview-item {
                margin-right: 170px;

                &:first-child {
                    margin-left: 14px;
                }

                &:last-child {
                    margin-right: 0;
                }

                &-count {
                    font-size: 28px;
                    font-weight: 600;
                    color: #33B900;
                    line-height: 40px;
                }

                &-name {
                    font-size: 16px;
                    font-weight: 400;
                    color: $text-primary;
                    line-height: 22px;
                }
            }
        }
    }

    .literature-database-publication-list-wrapper {
        .rows-explain-wrapper {
            margin-top: 0;
            position: sticky;
            top: 208px;
            z-index: 20;
            padding-bottom: 8px;
        }

        .literature-database-publication-list-desc {
            position: sticky;
            top: 240px;
            z-index: 20;
            font-size: 14px;
            font-weight: 500;
            color: #B3BAC5;
            padding: 2px 8px 10px;
            line-height: 16px;
            background: $bg-white;
        }
    }

    .literature-database-table {
        thead {
            position: sticky;
            top: 266px;
            z-index: 20;

            th {
                width: 50%;
            }
        }

        tbody {
            td {
                padding: 12px 16px !important;
            }
        }
    }
}
</style>
